import { Button, IconButton, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getCsrfToken } from "next-auth/react";
import { useRouter } from "next/router";
import { useMemo, useState } from "react";
import { AuthLayout } from "../../../src/layout/auth-layout";
import Close from "@mui/icons-material/Close";
import classes from "../auth-styles.module.scss";
import Link from "next/link";
import { unstable_getServerSession } from "next-auth";
import { authOptions } from "../../api/auth/[...nextauth]";
import { PAGE_OVERVIEW } from "../../../src/routes";
import dynamic from "next/dynamic";
import { ActionsWrapperProps } from "@dreipol/t3-ui";
const ActionsWrapper = dynamic<ActionsWrapperProps>(() =>
  import("@dreipol/t3-ui").then((m) => m.ActionsWrapper),
);

export const getServerSideProps = async (context) => {
  const csrfToken = (await getCsrfToken(context)) ?? null;
  const session = await unstable_getServerSession(
    context.req,
    context.res,
    authOptions,
  );
  if (session) {
    return {
      redirect: {
        permanent: false,
        destination: PAGE_OVERVIEW,
      },
    };
  }

  return {
    props: { csrfToken },
  };
};

export type LoginProps = {
  csrfToken: string;
};

enum LoginError {
  EMAIL_SIGNIN = "EmailSignin",
}

export const Login = ({ csrfToken }: LoginProps) => {
  const [t] = useTranslation();
  const router = useRouter();
  const hasError = useMemo(
    () => router.query.error === LoginError.EMAIL_SIGNIN,
    [router],
  );
  const [isSubmitted, setIsSubmitted] = useState(false);
  const onSubmit = () => {
    setIsSubmitted(true);
  };

  return (
    <AuthLayout>
      <ActionsWrapper align={"spread"} center className={classes.cardTitle}>
        <Typography color={"primary"} variant={"h5"}>
          {t("auth.login.title")}{" "}
        </Typography>
        <Link href={"/"}>
          <IconButton>
            <Close />
          </IconButton>
        </Link>
      </ActionsWrapper>

      <form method="post" action="/api/auth/signin/email" onSubmit={onSubmit}>
        <input name="csrfToken" type="hidden" defaultValue={csrfToken} />
        <TextField
          fullWidth
          className={classes.input}
          variant={"filled"}
          name={"email"}
          label={t("general.email")}
          placeholder={t("general.email")}
          error={hasError}
          helperText={hasError ? t("auth.login_failed") : ""}
        />
        <Button
          disabled={isSubmitted}
          type={"submit"}
          fullWidth
          variant={"contained"}
          color={"primary"}
        >
          {t("auth.login.button_label")}
        </Button>
      </form>

      <div className={classes.helperWrapper}>
        <Typography>{t("auth.login.help_text")}</Typography>
        <Link href={`mailto:${t("general.footer.info_mail")}`}>
          <Button className={classes.contactCta} variant={"outlined"} fullWidth>
            {t("general.contact")}
          </Button>
        </Link>
      </div>
    </AuthLayout>
  );
};

export default Login;
